import React, { useEffect, useState } from 'react';
import styles from '../../styles/layout/PageShellStickySideRail.module.css';

const DEFAULT_MIN_VIEWPORT_WIDTH = 1200;
const DEFAULT_STICKY_TOP = 'calc(60px + var(--announcement-banner-height, 0px))';

const joinClasses = (...values) => values.filter(Boolean).join(' ');

const useViewportWidth = () => {
  const getWidth = () => {
    if (typeof window === 'undefined') return DEFAULT_MIN_VIEWPORT_WIDTH;
    return window.innerWidth;
  };

  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
};

const PageShellStickySideRail = ({
  as: Component = 'div',
  children,
  rail = null,
  className = '',
  mainClassName = '',
  railClassName = '',
  railStickyClassName = '',
  railWidth = 340,
  minViewportWidth = DEFAULT_MIN_VIEWPORT_WIDTH,
  stickyTop = DEFAULT_STICKY_TOP,
  testId = 'page-shell-sticky-side-rail',
}) => {
  const viewportWidth = useViewportWidth();
  const showRail = Boolean(rail) && viewportWidth >= minViewportWidth;

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    document.documentElement.style.setProperty(
      '--page-shell-active-rail-width',
      showRail ? `${railWidth}px` : '0px'
    );

    return () => {
      document.documentElement.style.removeProperty('--page-shell-active-rail-width');
    };
  }, [railWidth, showRail]);

  return (
    <Component
      className={joinClasses(styles.layout, showRail ? styles.withRail : '', className)}
      style={{
        '--page-shell-sticky-rail-width': `${railWidth}px`,
        '--page-shell-sticky-rail-active-width': showRail ? `${railWidth}px` : '0px',
        '--page-shell-sticky-rail-top': stickyTop,
        '--page-shell-sticky-rail-min-height': `calc(100dvh - ${stickyTop})`,
      }}
      data-testid={testId}
    >
      <div className={joinClasses(styles.main, mainClassName)} data-testid={`${testId}-main`}>
        {children}
      </div>
      {showRail ? (
        <aside
          className={joinClasses(styles.rail, railClassName)}
          data-testid={`${testId}-rail`}
          aria-label="Spazio laterale destro"
        >
          <div
            className={joinClasses(styles.railSticky, railStickyClassName)}
            data-testid={`${testId}-rail-sticky`}
          >
            {rail}
          </div>
        </aside>
      ) : null}
    </Component>
  );
};

export default PageShellStickySideRail;
